import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import { memo } from 'react';

export const SysOutMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { sysOutContent: { text } = {} } = raw;

  if (text) {
    return <SystemMessage>{text}</SystemMessage>;
  }

  return null;
});
